export const navConfig = [
  {
    name: 'About Us',
    url: '/about',
  },
  {
    name: 'News',
    url: '/news',
  },
  {
    name: 'Classes',
    url: '/classes',
  },
  {
    name: 'Special Events',
    url: '/events',
  },
  {
    name: 'Prices',
    url: '/prices',
  },
  {
    name: 'Contacts',
    url: '/contacts',
  },
];
